import type { SubjectRef } from '@flux/shared';

/**
 * Chemin de l'écran qui montre l'objet d'un événement — pendant côté web de
 * `alerts/routes.ts::subjectPath` (serveur). Les deux doivent rester
 * d'accord : c'est la même carte d'URL vue des deux bouts.
 *
 * `null` quand aucun écran ne montre l'objet (événement système, ou objet
 * dont l'identifiant n'est pas exploitable).
 */
export function subjectLink(subject: SubjectRef | null): string | null {
  if (subject === null) {
    return null;
  }

  switch (subject.type) {
    case 'order':
      // L'identifiant est soit un `_id` local (24 hexa), soit un identifiant
      // Shopify : dans le second cas la fiche n'est pas adressable
      // directement, on retombe sur la recherche dans la liste.
      return isObjectId(subject.id)
        ? `/commandes/${subject.id}`
        : `/commandes?${new URLSearchParams({ search: subject.label || subject.id }).toString()}`;
    case 'invoice':
      return isObjectId(subject.id) ? `/commandes/factures/${subject.id}` : null;
    case 'file':
      return `/fichiers?${new URLSearchParams({ search: subject.label || subject.id }).toString()}`;
    case 'run':
      // Le type d'objet ne dit pas de quel flux vient le run : l'onglet Runs
      // filtré sur la date est le meilleur point d'atterrissage générique.
      return '/journal?view=runs';
    case 'store':
      return `/parametres?${new URLSearchParams({ tab: 'boutiques', store: subject.id }).toString()}`;
    case 'system':
      return null;
  }
}

function isObjectId(value: string): boolean {
  return /^[0-9a-f]{24}$/i.test(value);
}
